import { render, staticRenderFns } from "./YanzhengLogin.vue?vue&type=template&id=147ba451&scoped=true&"
import script from "./YanzhengLogin.vue?vue&type=script&lang=js&"
export * from "./YanzhengLogin.vue?vue&type=script&lang=js&"
import style0 from "./YanzhengLogin.vue?vue&type=style&index=0&id=147ba451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ba451",
  null
  
)

export default component.exports